/**
 * @generated SignedSource<<95e5ee90d2f00f2ca0cdb911b2b7930d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueSearchType = "HYBRID" | "LEXICAL" | "SEMANTIC" | "%future added value";
import type { FragmentRefs, Result } from "relay-runtime";
export type ListItemsPaginated_results$data = {
  readonly id?: string;
  readonly search: Result<{
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Issue";
        readonly id: string;
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly " $fragmentSpreads": FragmentRefs<"ApplyAssigneesBulkActionIssueFragment" | "IssueRow">;
      } | {
        readonly __typename: "PullRequest";
        readonly id: string;
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly " $fragmentSpreads": FragmentRefs<"PullRequestRow">;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined>;
    readonly issueCount: number;
    readonly issueSearchType: IssueSearchType | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  }, unknown>;
  readonly " $fragmentType": "ListItemsPaginated_results";
};
export type ListItemsPaginated_results$key = {
  readonly " $data"?: ListItemsPaginated_results$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemsPaginated_results">;
};

import SearchPaginatedQuery_graphql from './SearchPaginatedQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "search"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "labelPageSize",
  "variableName": "labelPageSize"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchRepository"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "labelPageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "query"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skip"
    },
    {
      "defaultValue": "ISSUE_ADVANCED",
      "kind": "LocalArgument",
      "name": "type"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/),
        "stream": true
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": SearchPaginatedQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ListItemsPaginated_results",
  "selections": [
    {
      "kind": "CatchField",
      "field": {
        "alias": "search",
        "args": [
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          },
          {
            "kind": "Variable",
            "name": "skip",
            "variableName": "skip"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "__Query_search_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "issueCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "issueSearchType",
            "storageKey": null
          },
          {
            "kind": "Stream",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "SearchResultItemEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v2/*: any*/),
                            (v3/*: any*/),
                            (v6/*: any*/),
                            {
                              "args": [
                                {
                                  "kind": "Variable",
                                  "name": "fetchRepository",
                                  "variableName": "fetchRepository"
                                },
                                (v7/*: any*/)
                              ],
                              "kind": "FragmentSpread",
                              "name": "IssueRow"
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "ApplyAssigneesBulkActionIssueFragment",
                              "selections": [
                                (v2/*: any*/),
                                {
                                  "alias": null,
                                  "args": [
                                    {
                                      "kind": "Literal",
                                      "name": "first",
                                      "value": 10
                                    }
                                  ],
                                  "concreteType": "AssigneeConnection",
                                  "kind": "LinkedField",
                                  "name": "assignedActors",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "AssigneeEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": null,
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "InlineFragment",
                                              "selections": [
                                                (v1/*: any*/),
                                                (v2/*: any*/),
                                                (v5/*: any*/),
                                                (v4/*: any*/),
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "kind": "ScalarField",
                                                  "name": "profileResourcePath",
                                                  "storageKey": null
                                                },
                                                {
                                                  "alias": null,
                                                  "args": [
                                                    {
                                                      "kind": "Literal",
                                                      "name": "size",
                                                      "value": 64
                                                    }
                                                  ],
                                                  "kind": "ScalarField",
                                                  "name": "avatarUrl",
                                                  "storageKey": "avatarUrl(size:64)"
                                                },
                                                {
                                                  "kind": "InlineFragment",
                                                  "selections": [
                                                    {
                                                      "alias": null,
                                                      "args": null,
                                                      "kind": "ScalarField",
                                                      "name": "isCopilot",
                                                      "storageKey": null
                                                    },
                                                    {
                                                      "alias": null,
                                                      "args": null,
                                                      "kind": "ScalarField",
                                                      "name": "isAgent",
                                                      "storageKey": null
                                                    },
                                                    {
                                                      "alias": null,
                                                      "args": null,
                                                      "kind": "ScalarField",
                                                      "name": "displayName",
                                                      "storageKey": null
                                                    }
                                                  ],
                                                  "type": "Bot",
                                                  "abstractKey": null
                                                }
                                              ],
                                              "type": "Actor",
                                              "abstractKey": "__isActor"
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": "assignedActors(first:10)"
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Repository",
                                  "kind": "LinkedField",
                                  "name": "repository",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "databaseId",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "isPrivate",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "isArchived",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "type": "Issue",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v2/*: any*/),
                            (v3/*: any*/),
                            (v6/*: any*/),
                            {
                              "args": [
                                (v7/*: any*/)
                              ],
                              "kind": "FragmentSpread",
                              "name": "PullRequestRow"
                            }
                          ],
                          "type": "PullRequest",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                "action": "THROW"
              }
            ]
          },
          {
            "kind": "Defer",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      "to": "RESULT"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/)
      ],
      "type": "Node",
      "abstractKey": "__isNode"
    }
  ],
  "type": "Searchable",
  "abstractKey": "__isSearchable"
};
})();

(node as any).hash = "300f94bbd9611320ac79e8f2daabe65c";

export default node;
